import { styled,
    experimental_sx as sx
 } from '@mui/material/styles';
 import LinearProgress, {
    linearProgressClasses,
} from '@mui/material/LinearProgress';
import Box, { BoxProps } from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Fragment } from 'react';

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => theme.unstable_sx({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[300],
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: theme.palette.secondary.main,
    },
}));

const BigBorderLinearProgress = styled(LinearProgress)(({ theme }) => theme.unstable_sx({
    height: 20,
    borderRadius: 10,
    marginTop: 3,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor:  theme.palette.grey[300],
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 10,
        backgroundColor: theme.palette.secondary.main,
    },
}));

export interface FFLinearProgressProps extends BoxProps {
    progressValue: number;
    big?: boolean;
    indicator?: boolean;
    percentage? : boolean;
}

const ProgressBox = styled(Box)(({ theme }) => theme.unstable_sx({
    flex: {
        xs: '1 0 60%',
        sm: '1 0 65%',
        md: '1 0 70%'
    },
    pb: 1,
    pt: 1,
    position: 'relative',
}));



export default function FFLinearProgress(props: FFLinearProgressProps) {
    return (
        <ProgressBox sx={props.sx}>
            {props.indicator && (
            <Fragment><Typography fontSize={10}
                sx={{
                    position: 'absolute',
                    left: `${props.progressValue}%`,
                    top: -20,
                    transform: 'translateX(-50%)'
                }}>{props.progressValue}{props.percentage ? '%': ''}

                </Typography>
                <ArrowDropDownIcon
                    sx={{
                        position: 'absolute',
                        left: `${props.progressValue}%`,
                        top: -17,
                        transform: 'translateX(-50%)',
                    }} />
            </Fragment>
            )}

            {!props.big && (<Fragment>

                <BorderLinearProgress value={props.progressValue} variant="determinate" />
            </Fragment>)}

            {props.big && <BigBorderLinearProgress value={props.progressValue} variant="determinate" />}
        </ProgressBox>
    )

}